export default __webpack_public_path__ + "static/media/icon-1.a4b55bb5.svg";